import api from "../../../services/api";
import { errorFormater } from "../../../services/errorHandler";

const getQueueDetails = (set) => async (id) => {
  try {
    set({ isLoading: true });

    const response = await api.get(`/queues/${id}/`);
    const result = response.data;
    set({
      queueDetails: result,
      queueId: id,
      isLoading: false,
    });
  } catch (error) {
    set({ isLoading: false });
    throw errorFormater(error.response);
  }
};

export default getQueueDetails;
